import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/components/CommonLayout.vue";
import Login from "@/views/LoginPage.vue";
import Dashboard from "@/views/DashboardPage.vue";
import UserList from "@/views/UserList.vue";
import UserUsage from "@/views/UserUsage.vue";
import OtaManagement from "@/views/OtaManagement.vue";
import { getCurrentUser } from "@/api/user";
import store from "@/store";
import UserProfile from "@/views/UserProfile.vue";
import PondList from "@/views/PondList.vue";
import DeviceList from "@/views/DeviceList.vue";
import DeviceResultList from "@/views/DeviceResultList.vue";
import DeviceVideoList from "@/views/DeviceVideoList.vue";
import VideoList from "@/views/VideoList.vue";
import AlertList from "@/views/AlertList.vue";
import BigScreenData from "@/views/data.vue";
import {
  checkTokenExpirationStatus,
  refreshAndGetNewAccessToken,
} from "@/utils/auth";
import { ElMessage } from "element-plus";
import PondMapView from "@/views/PondMapView.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "data",
        name: "BigScreenData",
        component: BigScreenData,
      },
      {
        path: "users",
        name: "UserList",
        component: UserList,
      },
      {
        path: "user-usage",
        name: "UserUsage",
        component: UserUsage,
      },
      {
        path: "ota",
        name: "OtaManagement",
        component: OtaManagement,
        meta: { otaAdmin: true },
      },
      {
        path: "profile",
        name: "UserProfile",
        component: UserProfile,
      },
      {
        path: "ponds",
        name: "PondList",
        component: PondList,
      },
      {
        path: "/pond-map",
        name: "PondMap",
        component: PondMapView, // 添加地图路由
      },
      {
        path: "devices",
        name: "DeviceList",
        component: DeviceList,
      },
      {
        path: "device-results",
        name: "DeviceResultList",
        component: DeviceResultList,
      },
      {
        path: "device-videos",
        name: "DeviceVideoList",
        component: DeviceVideoList,
      },
      {
        path: "videos",
        name: "VideoList",
        component: VideoList,
      },
      {
        path: "alerts",
        name: "AlertList",
        component: AlertList,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

async function enterAuthorizedRoute(to, next) {
  if (to.meta.otaAdmin) {
    try {
      const result = await getCurrentUser();
      if (result.code !== 0 || !result.data) throw new Error("权限读取失败");
      store.commit("setUser", result.data);
      if (!["admin", "superAdmin"].includes(result.data.userRole)) {
        ElMessage.error("仅管理员可访问 OTA 升级管理");
        next({ name: "Dashboard" });
        return;
      }
    } catch (error) {
      ElMessage.error("无法确认 OTA 访问权限，请重新登录");
      next({ name: "Login" });
      return;
    }
  }
  next();
}

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 登录页直接放行
  if (to.name === "Login") {
    next();
    return;
  }

  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  // 没有任何Token，强制登录
  if (!accessToken || !refreshToken) {
    next({ name: "Login" });
    return;
  }

  // 检查Token是否已过期
  if (checkTokenExpirationStatus("access")) {
    try {
      // 尝试刷新Token
      await refreshAndGetNewAccessToken();
      await enterAuthorizedRoute(to, next);
    } catch (error) {
      // 刷新失败，强制登录
      ElMessage.error("登录已过期，请重新登录");
      next({ name: "Login" });
    }
  } else {
    // Token有效，直接放行
    await enterAuthorizedRoute(to, next);
  }
});

export default router;
